/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.38"
        height="85.43"
        viewBox="0 0 82.38 85.43"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M55.47 7.32a1.27 1.27 0 0 1 1.32 1.19 1.25 1.25 0 0 1-1.19 1.31H26.9a1.25 1.25 0 0 1-.12-2.49h28.69Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M15.14 7.32a1.252 1.252 0 0 1 .13 2.5H3.62a1.05 1.05 0 0 0-1 1V81.9a1.08 1.08 0 0 0 1 1h75.24a1.07 1.07 0 0 0 1.06-1v-71a1.06 1.06 0 0 0-.94-1.05h-11.7a1.26 1.26 0 0 1-.13-2.5H78.8a3.58 3.58 0 0 1 3.56 3.37v71.17a3.57 3.57 0 0 1-3.37 3.56H3.62a3.58 3.58 0 0 1-3.56-3.44V10.89a3.56 3.56 0 0 1 3.37-3.55h11.71Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M37.08 58.46h-8.07a.71.71 0 0 1-.71-.71v-8.06a.71.71 0 0 1 .71-.71h8.07a.71.71 0 0 1 .71.71v8.06a.71.71 0 0 1-.71.71M20.8 58.46h-8.07a.71.71 0 0 1-.72-.71v-8.06a.71.71 0 0 1 .72-.71h8.07a.71.71 0 0 1 .71.71v8.06a.71.71 0 0 1-.71.71M53.38 58.46h-8.07a.71.71 0 0 1-.71-.71v-8.06a.71.71 0 0 1 .71-.71h8.07a.7.7 0 0 1 .72.71v8.06a.7.7 0 0 1-.72.71M69.64 58.46h-8.08a.7.7 0 0 1-.72-.69v-8.08a.72.72 0 0 1 .72-.69h8.06a.71.71 0 0 1 .72.7v8.07a.71.71 0 0 1-.71.72M37.08 74.77h-8.07a.7.7 0 0 1-.71-.7V66a.7.7 0 0 1 .7-.71h8.08a.71.71 0 0 1 .71.71v8.06a.7.7 0 0 1-.7.72M20.8 74.77h-8.07a.72.72 0 0 1-.72-.72V66a.73.73 0 0 1 .72-.72h8.07a.72.72 0 0 1 .76.66v8.12a.7.7 0 0 1-.7.72M53.38 74.77h-8.07a.7.7 0 0 1-.71-.7V66a.7.7 0 0 1 .7-.71h8.08a.72.72 0 0 1 .72.72v8.06a.72.72 0 0 1-.72.72"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M37.08 42.22h-8.07a.71.71 0 0 1-.71-.71v-8.07a.71.71 0 0 1 .7-.72h8.08a.7.7 0 0 1 .71.7v8.09a.71.71 0 0 1-.71.71"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M53.38 42.22h-8.07a.71.71 0 0 1-.71-.71v-8.07a.71.71 0 0 1 .7-.72h8.08a.72.72 0 0 1 .72.72v8.07a.71.71 0 0 1-.72.71M69.64 42.22h-8.08a.72.72 0 0 1-.72-.7v-8.07a.72.72 0 0 1 .72-.72h8.06a.72.72 0 0 1 .72.72v8.07a.71.71 0 0 1-.71.71"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M81.06 22a1.27 1.27 0 0 1 1.32 1.22 1.25 1.25 0 0 1-1.19 1.31H1.31A1.24 1.24 0 0 1 0 23.35a1.25 1.25 0 0 1 1.18-1.32ZM26.38 0H15.64a1.77 1.77 0 0 0-1.75 1.75v11.62a1.76 1.76 0 0 0 1.75 1.75h10.74a1.75 1.75 0 0 0 1.75-1.75V1.75A1.75 1.75 0 0 0 26.38 0Zm-.75 2.5v10.12h-9.25V2.5ZM66.73 0H55.97a1.76 1.76 0 0 0-1.75 1.75v11.62a1.76 1.76 0 0 0 1.75 1.75h10.76a1.75 1.75 0 0 0 1.75-1.75V1.75A1.76 1.76 0 0 0 66.73 0Zm-.75 2.5v10.12h-9.26V2.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'CalendarIcon';

export default Icon;
